<ul *ngIf="pages.length" class="pagination">
	<!-- first -->
	<li [ngClass]="{disabled:current_page === 1}" class="page-item previous-item">
		<a (click)="setPage(current_page - 1)" class="page-link">{{'Precedente' | translate}}</a>
	</li>
	<!-- pages -->
	<li *ngFor="let page of pages" [ngClass]="{active:current_page === page}" class="page-item number-item">
		<a (click)="setPage(page)" class="page-link">{{page}}</a>
	</li>
	<!-- next -->
	<li [ngClass]="{disabled:current_page === last_page}" class="page-item next-item">
		<a (click)="setPage(current_page + 1)" class="page-link">{{'Successiva' | translate}}</a>
	</li>
</ul>